import { Injectable, signal } from '@angular/core';

/**
 * Global connectivity banner state. Distinguishes "the request failed" (network/server down) from a
 * component's own "no results for this filter" empty state — before this existed, every list screen
 * silently rendered its normal empty state when the API was unreachable, with no way to tell a real
 * outage from a genuinely empty result set.
 */
@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  readonly hasError = signal(false);

  reportError(): void {
    this.hasError.set(true);
  }

  dismiss(): void {
    this.hasError.set(false);
  }
}
